import { render, staticRenderFns } from "./userLogin.vue?vue&type=template&id=5b1a7168&scoped=true&"
import script from "./userLogin.vue?vue&type=script&lang=js&"
export * from "./userLogin.vue?vue&type=script&lang=js&"
import style0 from "./userLogin.vue?vue&type=style&index=0&id=5b1a7168&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1a7168",
  null
  
)

export default component.exports